var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen w-full bg-gray-600 flex items-center justify-center"},[_c('img',{staticClass:"h-48",attrs:{"src":"/images/logo.png","alt":"Casa Auto"}})])
}]

export { render, staticRenderFns }